import { ClockControlType, TournamentMode } from './api/typings';

export const TIME_CONTROL: { [k in ClockControlType]: string } = {
  Blitz: 'Блиц',
  Rapid: 'Рапид',
  Classic: 'Классика',
  Bullet: 'Пуля',
};

export const TOURNAMENT_MODES: { [k in TournamentMode]: string } = {
  Team: 'Командный',
  Private: 'Личный',
  PrivateTeam: 'Лич-ком',
  TwoOnTwo: '2x2',
};
